(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function () {
  function initGallery(wrapper) {
    var mainEl  = wrapper.querySelector('[data-main-media]');
    var thumbsC = wrapper.querySelector('[data-thumbs-container]');
    if (!mainEl || !thumbsC) return;

    var mainImg = mainEl.querySelector('.bzn-product-media__img');

    thumbsC.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-thumb]');
      if (!btn) return;

      var src     = btn.dataset.mediaSrc;
      var srcset  = btn.dataset.mediaSrcset;
      var alt     = btn.dataset.mediaAlt;
      var mediaId = btn.dataset.mediaId;

      if (mainImg) {
        mainImg.classList.add('bzn-is-loading');
        var newImg = new Image();
        newImg.onload = function () {
          mainImg.src    = src;
          mainImg.srcset = srcset;
          mainImg.alt    = alt;
          mainImg.dataset.mediaId = mediaId;
          mainImg.classList.remove('bzn-is-loading');
        };
        newImg.src = src;
      } else {
        var img = document.createElement('img');
        img.src    = src;
        img.srcset = srcset;
        img.alt    = alt;
        img.className = 'bzn-product-media__img';
        img.dataset.mediaId = mediaId;
        var placeholder = mainEl.querySelector('.bzn-product-media__placeholder');
        if (placeholder) placeholder.remove();
        mainEl.appendChild(img);
      }

      thumbsC.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('bzn-is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('bzn-is-active');
      btn.setAttribute('aria-pressed', 'true');
    });

    document.addEventListener('bzn:variant-changed', function (e) {
      var featuredMediaId = e.detail && e.detail.featuredMediaId;
      if (!featuredMediaId) return;

      var matchThumb = thumbsC.querySelector('[data-media-id="' + featuredMediaId + '"]');
      if (matchThumb) matchThumb.click();
    });
  }

  document.querySelectorAll('[data-product-media]').forEach(initGallery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  function initVariantPicker(picker) {
    var productData = JSON.parse(picker.querySelector('[data-product-json]').textContent);
    var variants    = productData.variants;
    var options     = productData.options;
    var numOptions  = options.length;

    var selectedOptions = [];

    picker.querySelectorAll('[data-option-group]').forEach(function (group) {
      var idx    = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.bzn-is-active');
      selectedOptions[idx] = active ? active.dataset.optionValue : '';
    });

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (opt, i) { return v.options[i] === opt; });
      });
    }

    function updateButtonStates(changedIndex) {
      for (var i = 0; i < numOptions; i++) {
        if (i === changedIndex) continue;
        var otherGroup = picker.querySelector('[data-option-group][data-option-index="' + i + '"]');
        if (!otherGroup) continue;

        otherGroup.querySelectorAll('[data-option-btn]').forEach(function (btn) {
          var testOpts = selectedOptions.slice();
          testOpts[i] = btn.dataset.optionValue;
          var v = findVariant(testOpts);
          if (v && v.available) {
            btn.classList.remove('bzn-is-unavailable');
            btn.removeAttribute('aria-disabled');
          } else {
            btn.classList.add('bzn-is-unavailable');
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      }
    }

    function updateLabel(groupEl, value) {
      var lbl = groupEl.querySelector('[data-option-label]');
      if (lbl) lbl.textContent = value;
    }

    function emitVariantChanged(variant) {
      var event = new CustomEvent('bzn:variant-changed', {
        bubbles: true,
        detail: {
          variant: variant,
          available: variant ? variant.available : false,
          price: variant ? variant.price : null,
          comparePrice: variant ? variant.compare_at_price : null,
          featuredMediaId: variant && variant.featured_media ? variant.featured_media.id : null,
          productId: productData.id
        }
      });
      picker.dispatchEvent(event);
    }

    function updateURL(variant) {
      if (!variant) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateVariantInput(variant) {
      var input = picker.querySelector('[data-variant-id-input]');
      if (input && variant) input.value = variant.id;
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-btn]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var idx   = parseInt(btn.dataset.optionIndex, 10);
      var value = btn.dataset.optionValue;
      var group = picker.querySelector('[data-option-group][data-option-index="' + idx + '"]');

      group.querySelectorAll('[data-option-btn]').forEach(function (b) {
        b.classList.remove('bzn-is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('bzn-is-active');
      btn.setAttribute('aria-pressed', 'true');

      selectedOptions[idx] = value;
      updateLabel(group, value);

      var matched = findVariant(selectedOptions);
      if (matched) {
        updateVariantInput(matched);
        updateURL(matched);
        updateButtonStates(idx);
        emitVariantChanged(matched);
      } else {
        updateButtonStates(idx);
        emitVariantChanged(null);
      }
    });
  }

  document.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);
})();
  } catch(e) { console.error(e); }
})();

})();
